import { loadDeliveryMap } from '@widgets/delivery-map';

import { PAGE_LOADERS } from './routes';

// Ленивые части страниц, которых нет в их чанке: без них переход на главную показывал пустую
// секцию карты, пока её код идёт по сети
const PART_LOADERS = [loadDeliveryMap];

// Сколько фоновых загрузок ещё не закончено. Пока они идут, ошибка чанка — не повод перезагружать
// страницу: посетитель мог заполнять форму. Сбой настоящего перехода ловит RouteError
let pending = 0;

export const isBackgroundPreloading = (): boolean => pending > 0;

const whenIdle = (callback: () => void) => {
  if ('requestIdleCallback' in window) window.requestIdleCallback(callback, { timeout: 3000 });
  else setTimeout(callback, 300);
};

// После загрузки страница уже на экране: докачиваем код остальных, пока браузер простаивает.
// По одному модулю на каждый простой, а не все разом: импорт ~20 модулей одной пачкой исполнялся
// в окне гидратации и попадал в длинные задачи (Lighthouse 29.10.2026). Карта — последней: она
// нужна только при переходе на главную
export const preloadPages = (): void => {
  // Режим экономии трафика: качаем только то, что открыли
  const connection = (navigator as Navigator & { connection?: { saveData?: boolean } }).connection; // as: Network Information API нет в lib.dom
  if (connection?.saveData) return;

  const queue = [...Object.values(PAGE_LOADERS), ...PART_LOADERS];
  pending = queue.length;
  const next = () => {
    const load = queue.shift();
    if (!load) return;
    load()
      // Ошибку сети не показываем: при переходе страница загрузится заново обычным путём
      .catch(() => {})
      .finally(() => {
        pending -= 1;
        whenIdle(next);
      });
  };
  whenIdle(next);
};
